import { findCurrentAgencies } from "../report/reportActions";

export const transformProductionByDayHourInput =
  (values, taskKey) => (state) => {
    const agency = findCurrentAgencies(state, values.AgencyKeys);
    const transactionDates = [
      values.TransactionDate[0],
      values.TransactionDate[1],
    ];
    return {
      ...values,
      AgencyNameAndNumber: agency.FullName,
      ProducersTaskKey: taskKey,
      TransactionDate: transactionDates,
      FileName: `ProductionSummaryByDayHour_${agency.Number}`,
    };
  };
